import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = user
  const [sub, setSub] = useState(null);

  const refreshSub = async () => {
    try {
      const res = await api.get("/subscription/status");
      setSub(res.data);
      return res.data;
    } catch {
      setSub(null);
      return null;
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("haven_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        setUser(res.data);
        refreshSub();
      })
      .catch(() => {
        localStorage.removeItem("haven_token");
        setUser(false);
      });
  }, []);

  const loginSuccess = (data) => {
    localStorage.setItem("haven_token", data.token);
    setUser(data.user);
    refreshSub();
  };

  const logout = () => {
    localStorage.removeItem("haven_token");
    setUser(false);
    setSub(null);
  };

  const patchUser = (partial) => setUser((u) => (u ? { ...u, ...partial } : u));

  return (
    <AuthContext.Provider value={{ user, sub, refreshSub, loginSuccess, logout, patchUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
